import { useEffect, useState } from "react";
import { haveCommonElements } from "../Helpers";
import { ServiceContainerDto } from "../../../../Api/Model/ServiceContainerDto.csharp";
import { DoctorDto } from "../../../../Api/Model/DoctorDto.csharp";
import { LocationDto } from "../../../../Api/Model/LocationDto.csharp";

export const useFilteredDoctors = (
  doctors: DoctorDto[],
  service: ServiceContainerDto,
  location: LocationDto
) => {
  const getFilteredDoctors = () => {
    let filteredDoctors = doctors.filter(
      (d) => d.services.indexOf(service.id) != -1
    );

    if (location.id && location.id != "-1") {
      if (location.isLocation) {
        filteredDoctors = filteredDoctors.filter((d) =>
          haveCommonElements(d.centers, location.centers)
        );
      } else {
        filteredDoctors = filteredDoctors.filter((d) =>
          d.centers.includes(location.id)
        );
      }
    }

    return filteredDoctors;
  };

  const [filteredItems, setFilteredItems] = useState<DoctorDto[]>(
    getFilteredDoctors()
  );

  useEffect(() => {
    setFilteredItems(getFilteredDoctors());
  }, [location, service]);

  return {
    filteredDoctors: filteredItems,
  };
};
